<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.margin-tb-5 {
  margin: 5px 0;
}

.account_item {
  width: 237px;
  height: 101px;
  background: #4182EB;
  border-radius: 22px;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-right: 50px;

  .img_con {
    width: 61px;
    height: 61px;
    background: #FFFFFF;
    border-radius: 50%;
    line-height: 75px;
    text-align: center;
  }

  .amount_con {
    flex-grow: 1;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: right;

  }

  .amount_con :last-child {
    font-size: 26px;
    font-weight: 500;
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">能量更变列表</div>
      <div class="flex margin-t-10">
        <div class="account_item">
          <div class="img_con">
            <img src="../../../assets/detail/carbon.png" alt="">
          </div>
          <div class="amount_con">
            <p>累计充值能量值/g</p>
            <p>{{ erengyObj.allRechargeEnergyVal }}</p>
          </div>
        </div>
        <div class="account_item">
          <div class="img_con">
            <img src="../../../assets/detail/recovery.png" alt="">
          </div>
          <div class="amount_con">
            <p>累计发放能量值/g</p>
            <p>{{ erengyObj.allPulishEnergyVal }}</p>
          </div>
        </div>
        <div class="account_item">
          <div class="img_con">
            <img src="../../../assets/detail/erengy.png" alt="">
          </div>
          <div class="amount_con">
            <p>当前剩余能量值/g</p>
            <p>{{ erengyObj.leftEnergyVal }}</p>
          </div>
        </div>
      </div>
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="listDetailFun()">能量更改</button>
        <div class="flex-grow-1 flex-r-end margin-right-16">
          <!-- <div class="flex-r-center margin-right-16">
            <p class="margin-right-10 font-14">订单状态</p>
              <el-select
                v-model="queryInfo.setModel"
                size="small"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option label="正常充值" value="01"></el-option>
                <el-option label="更改(增加)" value="02"></el-option>
                <el-option label="更改(减少)" value="03"></el-option>
              </el-select>
          </div> -->
          <div class="flex-r-center">
            <p class="margin-right-10 font-14">操作月份</p>
            <div class="flex-r">
              <el-date-picker size="small" type="month" placeholder="请选择" value-format="yyyy-MM"
                v-model="queryInfo.setMonth">
              </el-date-picker>
            </div>
          </div>
        </div>
        <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
        <button class="common-bg-button" @click="reset()">重 置</button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination"
          v-on:pageUpdate="getListData(pagination, false, isNormal)"></ZD-pagination>
      </div>
    </div>
    <!-- 能量更改 -->
    <el-dialog title="能量更变" width="520px" :visible.sync="dialogShow">
      <el-form :model="formInfo" ref="energeRef" :rules="rules" label-width="80px">
        <el-form-item label="更变类型" prop="setModel">
          <el-radio-group v-model="formInfo.setModel">
            <el-radio label="01">正常充值</el-radio>
            <!-- <el-radio label="02">更改(增加)</el-radio>
                    <el-radio label="03">更改(减少)</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="更变值/g" prop="energyVal">
          <el-input-number clearable v-model="formInfo.energyVal" :precision="0" :min="1"
            size="small"></el-input-number>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input clearable v-model="formInfo.remark" maxlength="100" type="textarea" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex-r-center">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('energeRef')" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.popup.formInfo.restPassWord) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      pageConfig: pageConfig, // 页面配置
      mainTitle: '正常充电订单',
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      value1: true, //未使用
      chargeTime: [],
      mobile: '',
      isNormal: true,
      dialogShow: false,
      erengyObj: {},
      typeList: [],
      formInfo: {
        setModel: '01'
      },
      rules: {
        setModel: [{
          required: true,
          message: '请选择更变类型',
          trigger: 'change'
        }],
        energyVal: [{
          required: true,
          message: '请输入更变值',
          trigger: 'change'
        }],
      },
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      }, // 列操作按钮
      searchTime: [], //系统创建时间
      timeOptionRange: '',
      pickerOptions: {
        onPick: time => {
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: time => {
          const timeOptionRange = this.timeOptionRange;
          const secondNum = 60 * 60 * 24 * 1 * 1000;
          if (timeOptionRange) {
            return (time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() <
              timeOptionRange.getTime() - secondNum);
          }
          return false;
        }
      }
    }
  },
  methods: {
    //查找站点名称 获取数据
    init() {
      this.mobile = this.$store.state.userInfo.userPhone
      this.getStats()
      this.getListData(this.pagination, true)
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize;
      // _.queryInfo.mobile = reload?'':this.mobile;
      _.$H.post(_, _.$A.mayiEnerge.getList, _.queryInfo).then(res => {
        // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    getStats() {
      let _ = this
      _.$H.post(_, _.$A.mayiEnerge.statsGreenEnergyRecharge, {}).then(res => {
        // _.$H.post(_, _.$A.pile.pile, _.queryInfo).then((res) => {
        _.erengyObj = res.data.data || []
      })
    },
    pickdate(time) {
      console.log(time);
      let _ = this;
      // 拆分时间区间
      _.queryInfo.beginTime = time ? time[0] : ''
      _.queryInfo.endTime = time ? time[1] : ''
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error('请选择需要操作的对象');
        return false;
      }
      if (selections.length > 1) {
        this.$U.error('只能选择一个操作的对象');
        return false;
      }
      return true;
    },
    //页面查看方法
    listDetailFun() {
      let _ = this
      _.formInfo = {}
      _.dialogShow = true
      _.energeInfo = _.selections[0]
    },
    //选择时间
    handleDateChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0]
        this.queryInfo.dtTo = val[1]
      } else {
        delete this.queryInfo.dtFrom
        delete this.queryInfo.dtTo
      }
    },
    //重置
    reset() {
      this.queryInfo = {}
      this.chargeTime = []
      this.getListData(this.pagination, true, this.isNormal)
    },
    // 表单提交
    submitForm(formName) {
      let _ = this;
      let obj = _.formInfo;
      obj.mobile = this.mobile;
      obj.corpNo = this.$store.state.corpNo;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);
          _.$H.post(_, _.$A.mayiEnerge.addGreenEnergyRecharge, obj).then(res => {
            if (res.status === 200) {
              _.dialogShow = false
              _.init()
              _.$U.hideLoading(_);
              _.$U.success('更改成功！');
            }
          })
        }
      })
    },
    // 取消
    cancel() {
      this.dialogShow = false
    },
  },
  mounted() {
    this.init()
  },
  watch: {}
}
</script>
